export const polarToCartesian = /*glsl*/ `
    // Helper: Convert polar to cartesian
    #ifndef polarToCartesian
    vec2 polarToCartesian(float r, float theta) {
        return vec2(r * cos(theta), r * sin(theta));
    }
    #endif
`;

export const angleFromPoint = /*glsl*/ `
    // Helper: Convert polar to cartesian
    #ifndef angleFromPoint
    float angleFromPoint(vec2 point) {
        return atan(point.y, point.x);
    }
    #endif
`;

export const rgb2hsv = /*glsl*/ `
    #ifndef RGB_2_HSV
    #define RGB_2_HSV
    // RGB to HSV conversion
    vec3 rgb2hsv(vec3 c) {
        vec4 K = vec4(0.0, -1.0 / 3.0, 2.0 / 3.0, -1.0);
        vec4 p = mix(vec4(c.bg, K.wz), vec4(c.gb, K.xy), step(c.b, c.g));
        vec4 q = mix(vec4(p.xyw, c.r), vec4(c.r, p.yzx), step(p.x, c.r));

        float d = q.x - min(q.w, q.y);
        float e = 1.0e-10;
        return vec3(abs(q.z + (q.w - q.y) / (6.0 * d + e)), d / (q.x + e), q.x);
    }
    #endif
`;

export const hsv2rgb = /*glsl*/ `
    #ifndef HSV_2_RGB
    #define HSV_2_RGB
    // HSV to RGB conversion
    vec3 hsv2rgb(vec3 c) {
        vec4 K = vec4(1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0);
        vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);
        return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0, 1.0), c.y);
    }
    #endif
`;
